import { EverTutorWidgetShapeUtil as WidgetShapeUtil } from "@ever-tutor/et-widgets/et-ui";
import "@ever-tutor/et-widgets/style.css";
import "katex/dist/katex.min.css";
import { ET_CANVAS_SHAPE_UTILS } from "@ever-tutor/et-ui";

import { InkDrawShapeUtil } from "./InkDrawShapeUtil";

/**
 * The shape utils every view of the notepad renders with. InkDrawShapeUtil
 * replaces tldraw's built-in draw util and the shared set replaces its image
 * util (merged by type), so live and replayed views draw and export the same
 * way. Module-level for a stable identity across renders.
 */
export const NOTEPAD_SHAPE_UTILS = [
  ...ET_CANVAS_SHAPE_UTILS,
  WidgetShapeUtil,
  InkDrawShapeUtil,
];
